
import React from 'react';
import { Slider } from '@/components/ui/slider';
import { Label } from '@/components/ui/label';
import { Zap, Clock } from 'lucide-react';

interface ExecutorSettingsProps {
  speed: number;
  setSpeed: (speed: number) => void;
}

export const ExecutorSettings: React.FC<ExecutorSettingsProps> = ({
  speed,
  setSpeed
}) => {
  // Format speed label
  const getSpeedLabel = () => {
    if (speed === 0.5) return 'Slow';
    if (speed === 1) return 'Normal';
    if (speed === 2) return 'Fast';
    return 'Custom';
  };
  
  return (
    <div className="p-4 space-y-6">
      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <Label className="flex items-center gap-1">
            <Clock className="h-4 w-4" />
            Simulation Speed
          </Label>
          <div className="flex items-center gap-1 text-sm font-medium">
            {speed > 1 && <Zap className="h-3.5 w-3.5 text-amber-500" />}
            {getSpeedLabel()}
          </div>
        </div>
        <Slider
          value={[speed]}
          min={0.5}
          max={2}
          step={0.5}
          onValueChange={(values) => setSpeed(values[0])}
          className="py-4"
          aria-label="Simulation speed"
        />
        <div className="flex justify-between text-xs text-muted-foreground">
          <span>Slower</span>
          <span>Faster</span>
        </div>
      </div>
    </div>
  );
};
